<template>
    <BreadCrumb PageTitle="Modifier le recensement" />
    <EditRecensement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditRecensement from "@/components/Recensements/EditRecensement.vue";

export default defineComponent({
    name: "EditRecensementPage",
    components: {
        BreadCrumb,
        EditRecensement,
    },
});
</script>
